<template>
    <div>
        <OrderList :paginator="paginatedOrders"
                   :search="initSearch"
                   :max-search-results="maxSearchResults"
                   @reloadOrders="updateTableData"
        >
            <template v-slot:title>
                Alle Bestellungen
            </template>
            <template v-slot:description>
                Übersicht aller Bestellungen die von youbuyda verarbeitet wurden.
            </template>
            <template v-slot:toolbar>
                <OrderListFilters :init-order-states="initOrderStates"
                                  :init-range="initRange"
                                  :init-search="initSearch"
                                  :init-selected-order-types="initSelectedOrderTypes"
                                  @reloadOrders="updateTableData"
                />
            </template>
        </OrderList>
    </div>
</template>

<script>
import OrderList from '@components/Orders/OrderList.vue';
import OrderTypeSelect from "@components/Form/OrderTypeSelect.vue";
import Card from "@components/Cards/Card.vue";
import {scrollToTop} from '@composables/scrollToTop';
import OrderListFilter from "@components/Orders/Controls/OrderListFilter.vue";
import OrderListFilters from "@components/Orders/Controls/OrderListFilters.vue";
import {rewriteUrlNew} from "@composables/rewriteUrlNew";

export default {
    components: {OrderListFilters, OrderListFilter, Card, OrderList, OrderTypeSelect},

    props: {
        initSearch: String,
        initRange: Object,
        initOrderStates: Array,
        initSelectedOrderTypes: Object,
        paginatedOrders: Object,
        maxSearchResults: Number
    },

    methods: {
        updateTableData(only = ['paginatedOrders', 'initSearch', 'initRange', 'initOrderStates', 'initSelectedOrderTypes', 'tab']) {
            rewriteUrlNew('page', 1);
            this.$inertia.reload({only: only});
            scrollToTop();
        },
    }
};
</script>
